<div class="tw-flex tw-mt-2 tw-mr-4">
  <div class="matp-table-actions tw-ml-auto">
    @if (!updating) {
      <button
        mat-raised-button
        id="edit-mode-btn"
        color="primary"
        type="button"
        class="tw-w-28"
        (click)="toggleUpdating()"
      >
        <mat-icon>edit</mat-icon>
        編集
      </button>
    } @else {
      <button
        mat-raised-button
        class="tw-w-40"
        *ngIf="updating"
        (click)="cancelEditing()"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        mat-raised-button
        id="edit-btn"
        color="accent"
        type="submit"
        class="tw-w-40 tw-ml-2"
        (click)="updateTenantAlert()"
        [disabled]="tagNotifyEmailListFormGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        編集内容保存
      </button>
    }
  </div>
</div>
<div class="tw-flex">
  <div class="tw-flex tw-w-full tw-justify-evenly">
    <fieldset
      class="custom-fieldset tw-border-solid tw-border-[1px] tw-p-4 tw-m-4 tw-w-1/2"
    >
      <legend class="tw-text-lg tw-font-semibold">デバイス情報通知</legend>
      <div>
        <div class="tw-text-base tw-font-semibold">センサー情報</div>
        <div class="tw-flex tw-flex-col">
          <mat-checkbox
            name="selectAllSensors"
            color="primary"
            [disabled]="!updating"
            (change)="$event ? toggleAllSensors() : null"
            [checked]="hasValue(sensors) && isAllSelected(sensors)"
            [indeterminate]="hasValue(sensors) && !isAllSelected(sensors)"
          >
            全選択/全選択解除
          </mat-checkbox>

          <div *ngFor="let sensor of sensors" class="tw-ml-4">
            <mat-checkbox
              [(ngModel)]="sensor.checked"
              color="primary"
              [disabled]="!updating || sensor.keyword === 'mcdDetected'"
            >
              {{ sensor.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="tw-text-base tw-font-semibold">デバイスアラート</div>
        <div class="tw-flex tw-flex-col">
          <div *ngFor="let deviceAlert of deviceAlerts">
            <mat-checkbox
              [(ngModel)]="deviceAlert.checked"
              color="primary"
              [disabled]="!updating"
            >
              {{ deviceAlert.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset
      class="custom-fieldset tw-min-w-12 tw-border-solid tw-border-[1px] tw-p-4 tw-m-4 tw-w-1/2"
    >
      <legend class="tw-text-lg tw-font-semibold">配送情報通知</legend>
      <div>
        <div class="tw-text-base tw-font-semibold">配送情報</div>
        <div class="tw-flex tw-flex-col">
          <mat-checkbox
            name="selectAllShipments"
            color="primary"
            [disabled]="!updating"
            (change)="$event ? toggleAllShipments() : null"
            [checked]="hasValue(shipments) && isAllSelected(shipments)"
            [indeterminate]="hasValue(shipments) && !isAllSelected(shipments)"
          >
            全選択/全選択解除
          </mat-checkbox>

          <div *ngFor="let shipment of shipments" class="tw-ml-4">
            @if (shipment.keyword === "shipmentStatusUpdate") {
              <mat-checkbox
                [(ngModel)]="shipment.checked"
                color="primary"
                [disabled]="!updating"
                (change)="$event ? toggleAllShipmentStatusUpdate() : null"
                [checked]="
                  hasValue(shipmentStatusUpdate) &&
                  isAllSelected(shipmentStatusUpdate)
                "
                [indeterminate]="
                  hasValue(shipmentStatusUpdate) &&
                  !isAllSelected(shipmentStatusUpdate)
                "
              >
                {{ shipment.name }}
              </mat-checkbox>
              <div *ngFor="let status of shipmentStatusUpdate" class="tw-ml-4">
                <mat-checkbox
                  [(ngModel)]="status.checked"
                  color="primary"
                  [disabled]="!updating"
                >
                  {{ status.name }}
                </mat-checkbox>
              </div>
            } @else {
              <mat-checkbox
                [(ngModel)]="shipment.checked"
                color="primary"
                [disabled]="!updating"
              >
                {{ shipment.name }}
              </mat-checkbox>
            }
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</div>

<div class="tw-text-lg tw-font-semibold tw-mb-2 tw-ml-4">
  アラート通知メールアドレス
</div>
<div
  id="alert-notification-table-container"
  class="matp-table-container tw-max-h-full tw-max-w-full tw-min-w-[600px] tw-m-4"
>
  <div class="matp-table-area">
    <form [formGroup]="tagNotifyEmailListFormGroup">
      <table
        id="tag-table"
        class="matp-table"
        mat-table
        matSort
        [dataSource]="dataSource"
        formArrayName="tagEmailList"
      >
        <!-- タグ名 -->
        <ng-container matColumnDef="tagName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="matp-table-header-middle tw-w-2/5"
          >
            タグ名
          </th>
          <td
            mat-cell
            *matCellDef="let element; let index = index"
            [formGroupName]="index"
            class="matp-border-bottom"
          >
            <div class="tw-h-full tw-align-baseline tw-py-1">
              <mat-form-field
                *ngIf="updating"
                appearance="outline"
                class="matp-form-field-slim tw-w-full"
                [ngClass]="{
                  'margin-bottom':
                    hasNotifyEmailError(index) &&
                    getNotifyEmailFormGroup(index).controls.notifyEmail
                      .touched &&
                    !hasTagError(index),
                }"
              >
                <mat-select
                  formControlName="tag"
                  (selectionChange)="onTagNameChange($event.value, element)"
                >
                  <mat-option [value]="null"></mat-option>
                  <mat-option
                    *ngFor="let tag of sortDataSource(tagList)"
                    [value]="tag.tagId"
                    [disabled]="isTagSelected(tag.tagId)"
                  >
                    {{ tag.tagName }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    getNotifyEmailFormGroup(index).controls.tag.errors?.[
                      'tagRequired'
                    ]
                  "
                >
                  タグ名を選択してください。
                </mat-error>
              </mat-form-field>
            </div>
            <span class="tw-w-full" *ngIf="!updating">{{
              element.tagName
            }}</span>
          </td>
        </ng-container>

        <!-- 通知先メールアドレス -->
        <ng-container matColumnDef="notifyEmail">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="matp-table-header-middle tw-w-3/5"
          >
            通知先メールアドレス
          </th>
          <td
            mat-cell
            *matCellDef="let element; let index = index"
            [formGroupName]="index"
            class="matp-border-bottom"
          >
            <div class="tw-h-full tw-align-baseline tw-py-1">
              <mat-form-field
                *ngIf="updating"
                appearance="outline"
                class="matp-form-field-slim tw-w-full"
                [ngClass]="{
                  'margin-bottom':
                    (hasTagError(index) && !hasNotifyEmailError(index)) ||
                    (hasTagError(index) &&
                      getNotifyEmailFormGroup(index).controls.notifyEmail &&
                      !getNotifyEmailFormGroup(index).controls.notifyEmail
                        .touched),
                }"
              >
                <input
                  matInput
                  formControlName="notifyEmail"
                  placeholder="例: user1@example.com, user2@example.com"
                />
                <mat-error
                  *ngIf="
                    getNotifyEmailFormGroup(index).controls.notifyEmail
                      .errors?.['emailList']
                  "
                >
                  カンマ区切りで正しいメールアドレスを入力してください。
                </mat-error>
                <mat-error
                  *ngIf="
                    getNotifyEmailFormGroup(index).controls.notifyEmail
                      .errors?.['maxlength']
                  "
                >
                  メールアドレスは256文字以内で入力してください。
                </mat-error>
                <mat-error
                  *ngIf="
                    getNotifyEmailFormGroup(index).controls.notifyEmail
                      .errors?.['emailRequired']
                  "
                >
                  メールアドレスを入力してください。
                </mat-error>
              </mat-form-field>
            </div>
            <span class="tw-w-full" *ngIf="!updating">{{
              element.notifyEmail
            }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </form>
  </div>
</div>
